<template>
  <BaseScreen v-bind="screen">
    <div class="screen__faq">
      <BaseButton
        v-for="(question, index) in questions"
        :key="`question_${index}`"
        :text="question"
        class="screen__question"
        :disabled="index === activeIndex"
        @click="askQuestion(question, index)"
      />
    </div>
  </BaseScreen>
</template>

<script>
import { GLOBAL_EVENTS } from '@/App.vue';

import screenMixin from '@/mixins/screen';

import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'FaqScreen',
  mixins: [screenMixin],
  components: {
    BaseButton,
  },
  data() {
    return {
      activeIndex: null,
      selectedIndex: null,
      shouldSetIndex: false,
    };
  },
  computed: {
    screenCase() {
      return 'STEP_FAQ';
    },
    titleText() {
      return this.$t('faq.title');
    },
    questions() {
      return new Array(10).fill(1)
        .map((_, index) => this.$t(`faq.question_${index + 1}`));
    },
  },
  created() {
    this.initActions([
      [GLOBAL_EVENTS.ROBOT_REPLIC_START, this.setActiveIndex],
      [GLOBAL_EVENTS.ROBOT_REPLIC_FINISH, this.clearActiveIndex],
    ]);
  },
  beforeDestroy() {
    this.abortRobotReplic();
  },
  methods: {
    askQuestion(text, index) {
      this.abortRobotReplic();
      this.setAnswer(text);
      this.selectedIndex = index;
      this.shouldSetIndex = true;
    },
    setActiveIndex() {
      if (this.shouldSetIndex) {
        this.activeIndex = this.selectedIndex;
      }
    },
    clearActiveIndex() {
      this.activeIndex = null;
      this.shouldSetIndex = false;
    },
    setAnswer(text) {
      return this.$robot.dialogService.setAnswer(text);
    },
    abortRobotReplic() {
      return this.$robot.dialogService.abortRobotReplic();
    },
  },
};
</script>
